import { dynamicConfig } from './dynamicConfig';
// Get dynamic configuration
const config = dynamicConfig.getConfig();
export const UNBXD = {
    endpoint: config.unbxd.endpoint,
    siteKey: config.unbxd.siteKey,
    apiKey: config.unbxd.apiKey,
};
export const ALGOLIA = {
    appId: config.algolia.appId,
    apiKey: config.algolia.apiKey,
    indexName: config.algolia.indexName,
    suggestionsIndex: config.algolia.suggestionsIndex,
};
export const isDevelopment = process.env.NODE_ENV === 'development';
export const isProduction = process.env.NODE_ENV === 'production';
// ---------------------------------------------------------------------------
// Central application config – single source of truth
// ---------------------------------------------------------------------------
export const AppConfig = {
    /** Which search backend to use – falls back to using mock data */
    provider: config.provider,
    /** Mock platform to simulate when using mock provider */
    mockPlatform: config.mockPlatform,
    /** File in /mock/ folder to load when useMock === true */
    mockFile: process.env.MOCK_FILE || 'sample-search.json',
    /** Use HTTP mock server instead of static JSON */
    useMockServer: process.env.USE_MOCK_SERVER === 'true',
    /** Mock server URL */
    mockServerUrl: process.env.MOCK_SERVER_URL || 'http://localhost:3001',
    /** How UI state is pushed to the URL */
    routing: 'query-param',
    /** Default storefront query when the page first loads */
    defaultQuery: '*',
    /** Pagination defaults */
    page: {
        defaultSize: 24,
        maxSize: 48,
    },
    /** Display colour variants as swatches (true) or individual cards (false) */
    enableColourSwatch: false,
    /** Per‑provider secrets / endpoints */
    searchSettings: {
        unbxd: {
            apiUrl: `${UNBXD.endpoint}/${UNBXD.apiKey}/${UNBXD.siteKey}/search`,
        },
        algolia: {
            apiUrl: `https://${ALGOLIA.appId}-dsn.algolia.net/1/indexes/*/queries`,
        },
        boost: {
            apiUrl: config.boost.apiUrl,
            shop: config.boost.shop,
        },
        shopify: {
            domain: config.shopify.domain,
            storefrontToken: config.shopify.storefrontToken,
        },
    },
};
// Export search configuration for providers
export const searchConfig = config;
export default AppConfig;
